<template>
  <transition name="error-slide">
    <div v-show="value" class="error-banner" @click="remove">
      <div>{{ value }}</div>
      <div class="close-icon white icon-white">
        <XIcon />
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import XIcon from '@/assets/icons/x.svg';

  export default {
    name: 'Error',
    components: { XIcon },
    computed: mapState('error', ['value']),
    methods: mapActions('error', ['remove']),
  };
</script>

<style>
  .error-slide-leave-active,
  .error-slide-enter-active {
    transition: 0.3s;
  }
  .error-slide-enter {
    transform: translate(0, 100%);
    opacity: 1;
  }
  .error-slide-leave-to {
    transform: translate(0, 0);
    opacity: 0;
  }
  .error-banner {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 12px 32px;
    background-color: #e54444;
    font-family: noto-sans, sans-serif;
    color: #fff;
    text-align: center;
    z-index: 1000;
  }
</style>
